// Libs
import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

// CSS
import "./styles.scss"

// Components
import CloseIcon from "../../components/CloseIcon"

// Actions
import { changeTip, changeErr, changeSuccess } from '../App/actions'

class Warning extends Component {
  state = {
    visible: false,
    timeout: null
  }

  closeWarning = () => {
    const { changeErr, changeSuccess } = this.props

    this.setState({
      visible: false
    })

    changeErr('')
    changeSuccess('')
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { success, err } = nextProps
    const { visible, timeout } = this.state
    const { closeWarning } = this

    if (success || err) {
      if (timeout) {
        clearTimeout(timeout)
      }

      const newTimeout = setTimeout(() => {
        closeWarning()
      }, 8000)

      this.setState({
        visible: true,
        timeout: newTimeout
      })
    }
  }

  componentWillUnmount() {
    const { timeout } = this.props
    clearTimeout(timeout)
  }

  render() {
    const {
      gutter,
      gutterTop,
      gutterBottom,
      align,
      success,
      err
    } = this.props
    const { visible } = this.state

    const warningStyles = {
      margin: visible ? `${gutter / 2}px 0px` : 0,
      marginTop: `${gutterTop}px`,
      marginBottom: `${gutterBottom}px`,
      textAlign: align
    }

    const warningClassName = classNames(
      'warning',
      {
        'warning--error': err,
        'warning--success': success
      },
      {
        'warning--visible': visible,
        'warning--hidden': !visible
      }
    )

    return (
      <div style={warningStyles} className={warningClassName}>
        <p className="warning__content">
          {success || err}
        </p>
        <CloseIcon width={17} onClick={this.closeWarning} />
      </div>
    )
  }
}

Warning = connect(state => {
  return {
    err: state.app.err,
    success: state.app.success
  }
}, { changeErr, changeSuccess })(Warning)

export default Warning
